<template>
  <club-layout>
    <blue-panel-date-time-picker @apply="onApply" />
    <div id="container">
      <table-blue-invoice-history :transactions="invoicesTransactions" />
    </div>
  </club-layout>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import TableBlueInvoiceHistory from './tables/TableBlueInvoiceHistory';

  export default {
    name: "PageClubInvoiceHistory",
    components: {
      TableBlueInvoiceHistory,
    },
    computed: {
      ...mapGetters([
        'invoicesTransactions',
        'invoicesTransactionsMin',
        'invoicesTransactionsMax',
      ]),
    },
    methods: {
      ...mapActions(['getInvoicesTransactions']),
      async onApply({ min, max }) {
        await this.getInvoicesTransactions({ min, max });
      },
    },
  }
</script>

<style scoped>
  #container {
    margin-top: 35px;
  }
</style>
